<template>
    <dg-button :translate="false" :text="label" type="success" icon="el-icon-download" fieldSize="mini" :click="downloadWorkingDestinations"></dg-button>
</template>

<script>
export default {
  props: {
    label: {
      default: 'Working Destinations'
    }
  },
  methods: {
    ...$mapActions('voip-vendor-destination-status-api', {
      downloadWorkingDestinations: 'downloadWorkingDestinations'
    }),
  }
}
</script>
